import { render, staticRenderFns } from "./masterDetailsRow.vue?vue&type=template&id=b7b1fb32&"
import script from "./masterDetailsRow.vue?vue&type=script&lang=js&"
export * from "./masterDetailsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports